import { Client } from '@app/core/types/client';
import { User } from '@mi-front/core';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { Tooltip } from '@mui/material';
import { HTMLAttributes } from 'react';
import { useIntl } from 'react-intl';
import { impersonationMessages } from '../impersonation-messages';
import { ImpersonationUserListItem } from './ImpersonationUserListItem';

interface ImpersonationAutocompleteOptionProps {
  optionProps: HTMLAttributes<HTMLLIElement>;
  user: User & { client: Client };
  /** When true, shows the Enter hint (first match while filtering). */
  showEnterHint: boolean;
}

/**
 * Autocomplete option row; mirrors station navigator Enter-to-select affordance.
 */
export function ImpersonationAutocompleteOption({
  optionProps,
  user,
  showEnterHint,
}: ImpersonationAutocompleteOptionProps) {
  const { $t } = useIntl();

  return (
    <ImpersonationUserListItem
      {...optionProps}
      user={user}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      {showEnterHint ? (
        <Tooltip title={$t(impersonationMessages.enterToSelect)}>
          <KeyboardReturnIcon
            sx={{
              fontSize: 18,
              color: 'text.secondary',
              ml: 'auto',
              flexShrink: 0,
            }}
          />
        </Tooltip>
      ) : null}
    </ImpersonationUserListItem>
  );
}
